import { render, staticRenderFns } from "./DeleteReminderAlert.vue?vue&type=template&id=0813eada"
import script from "./DeleteReminderAlert.vue?vue&type=script&lang=js"
export * from "./DeleteReminderAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports